module.exports = __webpack_public_path__ + "static/media/lockCircled.34082d8c.svg";